import { render, staticRenderFns } from "./ProductRecommend.vue?vue&type=template&id=a0e96642&scoped=true"
import script from "./ProductRecommend.vue?vue&type=script&lang=js"
export * from "./ProductRecommend.vue?vue&type=script&lang=js"
import style0 from "./ProductRecommend.vue?vue&type=style&index=0&id=a0e96642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e96642",
  null
  
)

export default component.exports